import { render, staticRenderFns } from "./OrganisationManagement.vue?vue&type=template&id=320d0e80&"
import script from "./OrganisationManagement.vue?vue&type=script&lang=js&"
export * from "./OrganisationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports